import {Button, ButtonProps} from './Button';
import {Link, LinkProps} from './Link';

export enum ButtonLinkMods {
  Link = 'link',
  LinkFaded = 'link-faded',
  LinkBordered = 'link-bordered',
  LinkInherit = 'link-inherit',
  ButtonYellow = 'button_yellow',
  ButtonWhite = 'button_white',
  ButtonDark = 'button_dark',
  ButtonBlue = 'button_blue',
  ButtonGray = 'button_gray',
  ButtonTransparent = 'button_transparent',
}

export enum ButtonSize {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
}

export type ButtonLinkSize = ButtonSize;

export type ButtonLinkProps = ButtonProps | LinkProps;

// Договорились, что объединяем компоненты Button и Link в один - ButtonLink,
// потому что в проектах кнопки и ссылки выглядят почти всегда одинаково.
// Различие бывает только в поведении - отправить
// на отдельную страницу или выполнить действие
export function ButtonLink(props: LinkProps): JSX.Element;
export function ButtonLink(props: ButtonProps): JSX.Element;

export function ButtonLink(props: ButtonLinkProps): JSX.Element {
  return isLinkProps(props) ? <Link {...props} /> : <Button {...props} />;
}

function isLinkProps(props: ButtonLinkProps): props is LinkProps {
  return typeof props.href === 'string';
}
